import * as React from "react";

function SvgGraduationCap(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.96 17.97"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M4 11.63c.55 2.23 1.26 3.2 3.62 4.22S11.06 18 12 18s2-1 4.33-2 1.67-1.34 2.27-3.57L12 15.61zm19.38-5.79L13.4.32a3.29 3.29 0 00-2.84 0L.58 5.84C-.2 6.27-.2 7 .58 7.41l10 5.51a3.29 3.29 0 002.84 0l6.45-3.56-7-1.62a4.09 4.09 0 01-.88.1c-1.26 0-2.28-.6-2.28-1.34s1-1.34 2.28-1.34a2.57 2.57 0 012.12.84l7.41 2.4 1.86-1c.78-.4.78-1.13 0-1.56zm-3.05 10.44c-.08.46 1.54 1.21 1.69-.12.69-6-.5-7.73-.5-7.73l-1.67.93s1.42 1.33.48 6.92z" />
    </svg>
  );
}

const MemoSvgGraduationCap = React.memo(SvgGraduationCap);
export default MemoSvgGraduationCap;
